import React from 'react';
import { StatusType } from '../../api/api.types';

interface BooleanLabelProps {
  value: string;
}

class BooleanLabel extends React.PureComponent<BooleanLabelProps> {

  render() {
    return (
      <span
        className={
          this.props.value === 'true' ? 'badge badge-success' : 'badge badge-secondary'
        }
      >
        {this.props.value === 'true' ? 'YES' : 'NO'}
      </span>
    );
  }
}

export default BooleanLabel;
